<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        :disabled="typeof breadcrumb.link === 'undefined'"
        :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row class="ml-3">
      <v-flex xs12 lg12 md12>
        <h1 class="my-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout column class="ml-3" v-if="$store.getters.chatSocket !== null && $store.getters.chatSocket.connected">
      <v-flex>
        <v-layout row>
          <v-flex xs4 lg4 md4 class="white pa-3">
            <span class="title">Пользователи</span>
          </v-flex>
          <v-flex xs8 lg6 md8 class="white pa-3 ml-2" v-if="activeChat.id">
            <span class="title">{{activeChat.user.firstname + ' ' + activeChat.user.surname}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-layout row>
          <v-flex xs4 lg4 md4 class="scroll-y chat-contacts white" fill-height @scroll="onLoadChatList">
            <v-card class="elevation-0">
              <div v-if="chatItems.length === 0" class="ml-3">
                Список пользователей пуст
              </div>
              <v-list subheader>
                <v-list-tile
                  v-for="(chat, index) in chatItems"
                  :key="index"
                  avatar
                  id="chat-list"
                  @click="activeChat = chat"
                >
                  <v-list-tile-avatar class="chat-avatar">
                    <img :src="chat.user.photo">
                    <v-badge :color="chat.isOnline ? 'green' : 'red'" overlap>
                      <span slot="badge"></span>
                    </v-badge>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title :class="activeChat.id === chat.id ? 'primary--text' : ''">
                      {{chat.user.firstname + ' ' + chat.user.surname}}
                    </v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon :color="chat.lastMessage !== null && !chat.lastMessage.isRead && chatUser.id !== chat.lastMessage.user.id ? 'teal' : 'grey'">chat_bubble</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
          <v-flex xs8 lg6 md8 id="chat-dialog" class="white scroll-y chat-dialog ml-2" ref="chatDialog" @scroll="onLoadMessages" v-if="activeChat.id">
            <ul id="chat-message-list" class="chat-message-list mr-3">
              <li v-for="message in activeChatMessages" :class="message.user.id === activeChat.user.id ? '' : 'chat-message-self'">
                <v-chip label color="orange lighten-4">
                  <span v-if="message.attachmentFile === null">{{message.message}}</span>
                  <a v-else :href="message.attachmentFile.url" class="indigo--text lighten-4">{{message.attachmentFile.fileName + '.' + message.attachmentFile.extension}}
                    <img width="80%" :src="message.attachmentFile.urlResize" v-if="~message.attachmentFile.mimeType.indexOf('image')">
                  </a>
                  <span class="chat-message-time ml-3 my-3 font-italic">{{$moment(message.datetime).format('HH:mm - DD.MM.YY')}}</span>
                </v-chip>
              </li>
            </ul>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-layout row>
          <v-flex xs4 lg4 md4 class="white">

          </v-flex>
          <v-flex xs8 lg6 md8 class="white pt-3 px-3 ml-2" v-if="activeChat.id">
            <v-layout row>
              <v-flex xs2 lg2 md2>

              </v-flex>
              <v-flex xs8 lg8 md8>
                <div class="mb-3 mt-0">
                  <v-chip
                    v-for="(file, index) in attachmentFiles"
                    close
                    :key="file.id"
                    @input="removeFile(index)"
                  >
                    <strong>{{ file.fileName + '.' + file.extension }}</strong>
                  </v-chip>
                </div>
              </v-flex>
              <v-flex xs2 lg2 md2>

              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs2 lg2 md2>
                <v-btn depressed color="primary" class="chat-attach-btn" @click="$refs.fileInput.click()"><v-icon dark>attach_file</v-icon></v-btn>
                <input
                  ref="fileInput"
                  type="file"
                  style="display: none;"
                  accept="*/*"
                  @change="onFileChange"
                  multiple
                >
              </v-flex>
              <v-flex xs8 lg8 md8>
                <v-textarea
                  v-model="inputText"
                  id="chat-input-text"
                  auto-grow
                  outline
                  color="primary"
                  label=""
                  rows="1"
                  class="chat-input-text ma-0 pa-0"
                  placeholder="Написать сообщение..."
                  v-on:keydown.enter="enterChatInput('', $event)"
                ></v-textarea>
              </v-flex>
              <v-flex xs2 lg2 md2>
                <v-btn depressed color="primary" class="chat-send-btn" @click="sendMessage"><v-icon dark>send</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout v-else>
      <v-flex>
        <div class="ml-3">Нет соединения с сервером чата</div>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Чат', link: '/chat'}
      ],
      pageDataReady: {
        isReady: false
      },
      title: 'Чат',
      chatUser: null,
      chatItems: [],
      activeChat: {},
      activeChatMessages: [],
      messageLoaded: 0,
      chatsLoaded: 0,
      chatDialogScrollOffset: 0,
      chatListScrollOffset: 0,
      inputText: '',
      shiftDown: false,
      lastChatId: null,
      attachmentFiles: []
    }),
    methods: {
      pageDataStatus () {
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      async onLoadMessages (e) {
        this.chatDialogScrollOffset = e.target.scrollHeight - e.target.scrollTop
        if (this.messageLoaded < this.activeChatMessages.length) {
          if (e.target.scrollTop === 0) {
            if (this.activeChat.id && this.activeChatMessages.length > 0) {
              await this.$store.dispatch('getMessages', {chatId: this.activeChat.id, lastMessageId: this.activeChatMessages[0].id, limit: 20})
              this.messageLoaded = this.activeChatMessages.length
            }
          }
        }
      },
      async onLoadChatList (e) {
        if (this.chatsLoaded < this.chatItems.length) {
          if (e.target.scrollHeight - e.target.offsetHeight - e.target.scrollTop < 200) {
            await this.$store.dispatch('getChats', {limit: 20, lastId: this.lastChatId})
            this.chatsLoaded = this.chatItems.length
          }
        }
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)
        this.pageDataStatus()

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Чат', link: '/chat'}
        ]
        this.$store.commit('setPageTitle', 'Чат')

        this.chatItems = this.$store.getters.chatList
        this.chatUser = this.$store.getters.chatUser
        if (this.chatItems.length > 0) {
          this.lastChatId = this.chatItems[this.chatItems.length - 1].id
        }

        document.addEventListener('keydown', event => {
          if (event.key === 'Shift') {
            this.shiftDown = true
          }
        })

        document.addEventListener('keyup', event => {
          if (event.key === 'Shift') {
            this.shiftDown = false
          }
        })
      },
      enterChatInput (m, e) {
        if (!this.shiftDown) {
          e.preventDefault()
          this.sendMessage()
        }
      },
      async sendMessage () {
        if (this.attachmentFiles.length > 0) {
          for (let i = 0; i < this.attachmentFiles.length; i++) {
            await this.$store.dispatch('sendMessage', {chatId: this.activeChat.id, message: '', attachmentFile: this.attachmentFiles[i]})
          }
          this.attachmentFiles = []
        }
        if (this.inputText.trim() !== '') {
          let message = this.inputText.trim()
          this.$store.dispatch('sendMessage', {chatId: this.activeChat.id, message: message})
          this.inputText = ''
          let chatInputText = document.getElementById('chat-input-text')
          chatInputText.style.height = 0
        }
      },
      async onFileChange (event) {
        let rejectedFiles = []
        let files = {}
        Object.keys(event.target.files).forEach((key) => {
          if (event.target.files[key].size < 1024 * 1024 * 10) {
            files[key] = event.target.files[key]
          } else {
            rejectedFiles.push(event.target.files[key])
          }
        })

        await this.$store.dispatch('chatUploadFiles', {files: files})
          .then((data) => {
            this.attachmentFiles = this.attachmentFiles.concat(data.files)
          })
      },
      removeFile (index) {
        this.attachmentFiles.splice(index, 1)
        this.attachmentFiles = [...this.attachmentFiles]
      }
    },
    created () {
      this.onCreated()
    },
    updated () {
      let chatDialog = document.getElementById('chat-dialog')
      let chatList = document.getElementById('chat-list')
      let chatMessageList = document.getElementById('chat-message-list')
      if (chatDialog && chatMessageList) {
        if (chatDialog.offsetHeight > chatMessageList.offsetHeight) {
          chatMessageList.classList.add('align-bottom')
        } else {
          chatMessageList.classList.remove('align-bottom')
        }
      }

      if (typeof chatDialog === 'object' && chatDialog !== null && 'scrollTop' in chatDialog) {
        chatDialog.scrollTop = chatDialog.scrollHeight - this.chatDialogScrollOffset
      }
      if (typeof chatList === 'object' && chatList !== null && 'scrollTop' in chatList) {
        chatList.scrollTop = chatList.scrollHeight - this.chatListScrollOffset
      }
    },
    watch: {
      '$store.getters.chatList' () {
        this.chatItems = this.$store.getters.chatList
        if (this.chatItems.length === 0) {
          this.activeChat = {}
          this.lastChatId = null
        } else {
          this.lastChatId = this.chatItems[this.chatItems.length - 1].id
        }
      },
      '$store.getters.chatOnlineList' () {
        // this.chatItems = this.$store.getters.chatList
      },
      '$store.getters.chatUser' () {
        this.chatUser = this.$store.getters.chatUser
      },
      '$store.getters.chatMessage' () {
        if (this.$store.getters.chatMessage.message.chatId === this.activeChat.id) {
          this.activeChatMessages.push(this.$store.getters.chatMessage.message)
          this.$store.dispatch('onReadMessage', {messageId: this.$store.getters.chatMessage.message.id})
          this.$store.getters.chatMessage.message.isRead = true
          this.$store.dispatch('getUnreadedCount', {})
        }
        let hasChat = false
        for (let i = 0; i < this.chatItems.length; i++) {
          if (this.chatItems[i].id === this.$store.getters.chatMessage.message.chatId) {
            let chat = this.chatItems.splice(i, 1)
            this.chatItems.unshift(chat[0])
            hasChat = true
            break
          }
        }
        if (!hasChat) {
          for (let i = 0; i < this.$store.getters.chatOnlineList.length; i++) {
            if (this.$store.getters.chatOnlineList[i].id === this.$store.getters.chatMessage.message.chatId) {
              this.chatItems.unshift(this.$store.getters.chatOnlineList[i])
              this.chatItems[0].isOnline = true
              break
            }
          }
        }
      },
      '$store.getters.chatMessages' () {
        if (this.$store.getters.chatMessages.length > 0) {
          if (this.$store.getters.chatMessages[0].chatId === this.activeChat.id) {
            for (let i = 0; i < this.$store.getters.chatMessages.length; i++) {
              if (!this.$store.getters.chatMessages[i].isRead) {
                this.$store.dispatch('onReadMessage', {messageId: this.$store.getters.chatMessages[i].id})
              }
            }
            this.activeChatMessages = this.$store.getters.chatMessages.concat(this.activeChatMessages)
          }
          this.$store.commit('setChatMessages', [])
          this.$store.dispatch('getUnreadedCount', {})
        }
      },
      'activeChat' () {
        if ('id' in this.activeChat) {
          this.activeChat.lastMessage.isRead = true
          for (let i = 0; i < this.chatItems.length; i++) {
            if (this.chatItems[i].id === this.activeChat.id) {
              this.activeChatMessages = []
              if (this.chatItems[i].lastMessage !== null) {
                this.activeChatMessages.push(this.chatItems[i].lastMessage)
                this.$store.dispatch('onReadMessage', {messageId: this.chatItems[i].lastMessage.id})
              }
              break
            }
          }
          if (this.activeChatMessages.length > 0) {
            this.$store.dispatch('getMessages', {chatId: this.activeChat.id, lastMessageId: this.activeChatMessages[0].id, limit: 20})
          }
        }
        this.messageLoaded = 0
        this.chatDialogScrollOffset = 0
        this.chatListScrollOffset = 0
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Chat.vue